define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FWpPrAsset", "../domain", "../services", "../services/EventManager", "./FWpPrApproval"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FWpPrAsset_1, domain_1, services_1, EventManager_1, FWpPrApproval_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpPr = void 0;
    class FWpPr extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DueDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DueDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WorksCompleted", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WorksCompletedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ProgressDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ProgressDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RiskIssueActionDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RiskIssueActionDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EstimateCompletionDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EstimateCompletionDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LastReminderSentDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LastReminderSentDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpPrAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFWpPrAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpPrAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Approval", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpPr.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWorksProject = parent;
            this.WpId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FWpPrAsset = [];
        }
        onRead(entity, parent) {
            this.FWorksProject = parent;
            this.FWpPrAsset = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpId = (0, EntityUtil_1.toInt)(entity.WpId);
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.StatusReq = (0, EntityUtil_1.toInt)(entity.StatusReq);
            a.StatusPrev = (0, EntityUtil_1.toInt)(entity.StatusPrev);
            a.StatusDate = b.StatusDate;
            a.StatusUser = b.StatusUser;
            a.DueDate = b.DueDate;
            a.WorksCompleted = (0, EntityUtil_1.toInt)(entity.WorksCompleted);
            a.ProgressDesc = b.ProgressDesc;
            a.RiskIssueActionDesc = b.RiskIssueActionDesc;
            a.EstimateCompletionDate = b.EstimateCompletionDate;
            a.LastReminderSentDate = b.LastReminderSentDate;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.FWpPrAsset = this.mergeArray(a.FWpPrAsset, b.FWpPrAsset, FWpPrAsset_1.FWpPrAsset);
            a.SelectedFWpPrAsset = a.SelectedFWpPrAsset && a.FWpPrAsset.find(x => x.Id == a.SelectedFWpPrAsset.Id) ? a.SelectedFWpPrAsset : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.Approval && this.Approval.evaluateStatus();
        }
        onReady() {
            this.Approval = new FWpPrApproval_1.FWpPrApproval(this);
            this.validate();
            this.addChangeEventAction("WorksCompleted", () => this.validate());
            this.addChangeEventAction("ProgressDesc", () => this.validate());
            this.addChangeEventAction("RiskIssueActionDesc", () => this.validate());
            this.addChangeEventAction("EstimateCompletionDate", () => this.validate());
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpPr.AliasName);
            this.reset();
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                if (this.WorksCompleted == 0) {
                    this.validateReqString(validationState, "ProgressDesc", "Work Progress", false);
                    this.validateReqString(validationState, "RiskIssueActionDesc", "Risks/Problems", false);
                    this.validateReqDate(validationState, "EstimateCompletionDate", "Expected Completion Date", false);
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpId", "Works Project ID");
                this.validateReqNumber(validationState, "Status", "Status");
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpId", "Works Project ID");
                this.validateReqNumber(validationState, "Status", "Status");
                this.validateReqDate(validationState, "DueDate", "DUE_DATE");
                this.validateReqDate(validationState, "EstimateCompletionDate", "ESTIMATE_COMPLETION_DATE");
                this.validateReqDate(validationState, "LastReminderSentDate", "LAST_REMINDER_SENT_DATE");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FWpPrAsset) {
                for (let x of this.FWpPrAsset) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpId: this.WpId,
                Status: this.Status,
                StatusReq: this.StatusReq,
                StatusPrev: this.StatusPrev,
                StatusDate: this.StatusDate,
                StatusUser: this.StatusUser,
                DueDate: this.DueDate,
                WorksCompleted: this.WorksCompleted,
                ProgressDesc: this.ProgressDesc,
                RiskIssueActionDesc: this.RiskIssueActionDesc,
                EstimateCompletionDate: this.EstimateCompletionDate,
                LastReminderSentDate: this.LastReminderSentDate,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                FWpPrAsset: this.FWpPrAsset.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get StatusValue() {
            var _a;
            let k = this.StatusReq ? this.StatusReq : this.Status;
            let v = (_a = domain_1.FWpPrStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.StatusReq ? `${v}*` : v;
        }
        static sync() {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Syncing progress reports (available test env only)");
                services_1.SrmsServiceManager.Instance.Facility.syncWpProgressReports().then(() => {
                    resolve();
                });
            });
        }
    }
    exports.FWpPr = FWpPr;
    Object.defineProperty(FWpPr, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpPr"
    });
    Object.defineProperty(FWpPr, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project Progress Report"
    });
    Object.defineProperty(FWpPr, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpId", "Status", "StatusReq", "StatusPrev", "StatusDate", "StatusUser", "DueDate", "WorksCompleted", "ProgressDesc", "RiskIssueActionDesc", "EstimateCompletionDate", "LastReminderSentDate", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser"]
    });
    Object.defineProperty(FWpPr, "WpIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "StatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "StatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "StatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "StatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "StatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "StatusUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpPr, "StatusUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "DueDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "WorksCompletedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "ProgressDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FWpPr, "ProgressDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Work Progress/What have you achieved so far?"
    });
    Object.defineProperty(FWpPr, "ProgressDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "RiskIssueActionDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FWpPr, "RiskIssueActionDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Risks/Problems re completing works. If delayed, what action will be taken to complete works?"
    });
    Object.defineProperty(FWpPr, "RiskIssueActionDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "EstimateCompletionDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "LastReminderSentDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpPr, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPr, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPr, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpPr, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "WpId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "WpIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "StatusUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "DueDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "DueDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "WorksCompleted", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "WorksCompletedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "ProgressDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "ProgressDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "RiskIssueActionDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "RiskIssueActionDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "EstimateCompletionDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "EstimateCompletionDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "LastReminderSentDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "LastReminderSentDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "FWpPrAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "SelectedFWpPrAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "FWpPrAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "FWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPr.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPr.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPr.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPr.prototype, "Approval", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpPr.prototype, "StatusValue", null);
});
